export enum AssessmentStatus {
  NOT_STARTED = 1,
  IN_PROGRESS = 2,
  SYSTEM_ARCHIVED = 3,
  USER_ARCHIVED = 4,
  DOCUMENTED = 5,
  AMEND_IN_PROGRESS = 6,
  DELETED = 7,
}

export const AssessmentStatusDisplay: Record<AssessmentStatus, string> = {
  [AssessmentStatus.NOT_STARTED]: 'Not Started',
  [AssessmentStatus.IN_PROGRESS]: 'In Progress',
  [AssessmentStatus.SYSTEM_ARCHIVED]: 'System Archived',
  [AssessmentStatus.USER_ARCHIVED]: 'User Archived',
  [AssessmentStatus.DOCUMENTED]: 'Documented',
  [AssessmentStatus.AMEND_IN_PROGRESS]: 'Amend In Progress',
  [AssessmentStatus.DELETED]: 'Deleted',
};
